import _extends from "@babel/runtime-corejs3/helpers/extends";
import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/values";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import React, { useState } from 'react';
import * as _ from "../../../util/lodash";
import { ConfigService } from "../../../services";
import Layout from "../../core/layout";
import Label from "../../core/label";
import CKImage from "../../core/image";
import Icon from "../../core/icon";
import SimplePopup from "../../core/simple-popup";
import { positions, sizes, widths, font, icons, colors } from "../../../enums";
var noPadding = {
  padding: 0
};
var noMargin = {
  margin: 0
};
var pexelsTexts = ['Our partnership with Pexels gives you access to over 3 million photos, images and videos', 'Free to use in your Grow experiences with no additional licensing required'];
/**
 * Subcomponent to return the Pexels copy text and popup.
 */

var PexelsInfo = function PexelsInfo() {
  var _useState = useState(false),
      popupVisible = _useState[0],
      setPopupVisible = _useState[1];

  var handlePopupClose = function handlePopupClose() {
    setPopupVisible(false);
  };

  var handlePopupOpen = function handlePopupOpen() {
    setPopupVisible(true);
  };

  var ConsoleKitConfig = _valuesInstanceProperty(ConfigService).call(ConfigService);

  return /*#__PURE__*/React.createElement(Layout, {
    padding: {
      horizontal: 0,
      vertical: sizes.X2
    }
  }, /*#__PURE__*/React.createElement(Layout.Column, null, /*#__PURE__*/React.createElement("span", {
    className: "pexels-info"
  }, "All Pexels images are published under the", ' ', /*#__PURE__*/React.createElement("a", {
    href: "https://www.pexels.com/license/",
    target: "_blank"
  }, "Pexels License"), ". Powered by", ' ', /*#__PURE__*/React.createElement("a", {
    href: "https://www.pexels.com/",
    target: "_blank"
  }, "Pexels")), /*#__PURE__*/React.createElement(SimplePopup, {
    trigger: /*#__PURE__*/React.createElement(Icon, {
      name: icons.INFO,
      size: sizes.X3,
      color: colors.BASE,
      style: {
        marginLeft: '4px'
      },
      onClick: handlePopupOpen
    }),
    position: positions.BOTTOM,
    offset: [0, 0],
    isOpen: popupVisible,
    onClose: handlePopupClose,
    onOpen: handlePopupOpen,
    isBasic: true,
    isHoverable: true,
    hideOnScroll: true,
    mouseLeaveDelay: 200
  }, /*#__PURE__*/React.createElement("div", {
    className: "library-select-pexels-popup"
  }, /*#__PURE__*/React.createElement("div", {
    className: "library-select-pexels-popup__header"
  }, /*#__PURE__*/React.createElement(Layout, {
    style: _extends({}, noPadding, noMargin)
  }, /*#__PURE__*/React.createElement(Layout.Row, {
    columnStyles: {
      verticalAlign: positions.verticalAlign.MIDDLE
    },
    style: noPadding
  }, /*#__PURE__*/React.createElement(Layout.Column, {
    columnWidth: widths.FOUR
  }, /*#__PURE__*/React.createElement(CKImage, {
    src: ConsoleKitConfig.assetUrls.assetFolderPath + "misc/pexels-logo-white.svg"
  })), /*#__PURE__*/React.createElement(Layout.Column, {
    style: noPadding
  }, /*#__PURE__*/React.createElement(Label, {
    text: "Pexels",
    color: colors.WHITE,
    size: sizes.X6,
    font: {
      weight: font.weights.MEDIUM
    },
    style: {
      marginLeft: '-4px'
    }
  }))))), /*#__PURE__*/React.createElement(Layout, {
    style: {
      margin: '12px 12px 0'
    }
  }, _mapInstanceProperty(pexelsTexts).call(pexelsTexts, function (item, index) {
    return /*#__PURE__*/React.createElement(Layout.Row, {
      style: noPadding,
      key: item
    }, /*#__PURE__*/React.createElement(Layout.Column, {
      columnWidth: widths.TWO,
      style: _extends({}, noPadding, noMargin)
    }, /*#__PURE__*/React.createElement(CKImage, {
      src: ConsoleKitConfig.assetUrls.assetFolderPath + "misc/pexels-logo.svg"
    })), /*#__PURE__*/React.createElement(Layout.Column, {
      style: _extends({}, noPadding, {
        margin: '-2px 12px 12px 4px'
      })
    }, /*#__PURE__*/React.createElement(Label, {
      text: item,
      size: sizes.X4,
      style: _extends({}, noPadding)
    })));
  }, this))))));
};

export default PexelsInfo;
//# sourceMappingURL=pexels-info.js.map